<div class="container">
  <h2>Calendário</h2>
  <div class="box">
    <div class="agenda">
      <app-agenda></app-agenda>
    </div>

    <div class="calendario">
      <!-- <p-calendar class="calendar max-w-full" [(ngModel)]="date" [inline]="true">
      </p-calendar> -->

      <p-calendar class="calendar max-w-full" [(ngModel)]="selectedDates" [inline]="true" selectionMode="multiple">
        <ng-template let-day pTemplate="date">
          <div class="custom-date">
            {{ day.day }}
            <span *ngIf="day.date && hasEvent(day.date)" class="event-indicator"></span>
          </div>
        </ng-template>
      </p-calendar>
      
      <div class="evento-programado">
        <app-evento-programado></app-evento-programado>
      </div>
    </div>
  </div>
</div>